<div class="row dsp-negative-margin">
  <div class="column small-12 medium-12 large-12">
    <!-- <div class="mos-u-spacer--margin-bottom-xxlg"> -->
    <div id="portfolio-valuation-pendo-row" class="row mos-u-spacer--margin-bottom-lg">
      <div id="portfolio-valuation-pendo-column" class="columns medium-12">
        <div class="mos-u-shadow-depth-2 mos-u-spacer--padding-md dsp-widget-background mos-u-border--top-md"
          [id]="'portfolio-valuation'">
          <div *ngIf="loading$ | async" class="row">
            <div class="dsp-overview-spinner-wrapper">
              <div class="dsp-overview-spinner"></div>
            </div>
          </div>
          <div *ngIf="!(loading$ | async)" class="row">
            <div class="columns">
              <h3 *ngIf="showPortfolioValuation$ | async" class="mos-u-spacer--margin-none"
                [id]="'portfolio-valuation-header'">
                <a class="dsp-link" [routerLink]="'/valuation'" [id]="'portfolio-valuation-header-link'">
                  Portfolio Valuation <atlas-icon [id]="'portfolio-valuation-link-icon'" [icon]="'hyperlink'"
                    [collection]="'user-interface'" [size]="'medium'"></atlas-icon>
                </a><atlas-icon *ngIf="(notes$ | async)?.overview[ 'portfolio-valuation' ] !== undefined"
                  #portfolioValuationTooltip="haloTooltip"
                  (click)="portfolioValuationTooltip.toggle(); $event.stopPropagation()"
                  class="dsp-overview-tooltip-trigger" [haloTooltipWithArrow]="true"
                  [haloTooltip]="(notes$ | async)?.overview[ 'portfolio-valuation' ]"
                  [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                  [haloTooltipClass]="(isMobile$ | async) ? 'dsp-overview-mobile-tooltip' : null"
                  [haloTooltipTouchGestures]="'on'" [id]="'portfolio-valuation-note-icon'" [icon]="'c-info'"
                  [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                </atlas-icon>
              </h3>
              <h3 *ngIf="!(showPortfolioValuation$ | async)" [id]="'portfolio-valuation-header'"
                class="mos-u-spacer--margin-none">
                Portfolio Valuation
              </h3>
              <p *ngIf="showPortfolioValuation$ | async" class="mos-u-spacer--margin-none dsp-widget-subtitle">
                as at
                <span [id]="'portfolio-valuation-date'">{{ portfolioValuationDate$ | async }}</span>
              </p>
              <div *ngIf="!(showPortfolioValuation$ | async)" [style.height.px]="24"></div>
            </div>
            <div *ngIf="((showPortfolioValuation$ | async) && !(isMobile$ | async))"
              class="columns shrink mos-u-align-center--vertical">
              <!-- <h1 class="mos-u-spacer--margin-none dsp-valuation-value">
                $<span [id]="'portfolio-valuation-value'">{{ portfolioValuationValue$ | async | decimal }}</span>
                <span class="mos-u-text-size--md" [id]="'portfolio-valuation-currency'">{{ currency$ | async }}</span>
              </h1> -->
              <h1 class="mos-u-spacer--margin-none dsp-valuation-value">
                ${{ portfolioValuationValue$ | async | decimal }}
                <span class="" [id]="'portfolio-valuation-currency'">{{ currency$ | async }}</span>
              </h1>
            </div>
            <div *ngIf="!(showPortfolioValuation$ | async)" class="columns shrink mos-u-align-center--vertical">
              <h3 class="mos-u-spacer--margin-none dsp-valuation-value">
                No Data Available
                <!-- <span [id]="'portfolio-valuation-no-data'">No Data Available</span> -->
              </h3>
            </div>
          </div>
          <div *ngIf="!(loading$ | async)" class="row">
            <div *ngIf="((showPortfolioValuation$ | async ) && (isMobile$ | async))"
              class="columns shrink mos-u-align-center--vertical">
              <h1 class="mos-u-spacer--margin-none dsp-valuation-value">
                ${{ portfolioValuationValue$ | async | decimal }}
                <span class="" [id]="'portfolio-valuation-currency'">{{ currency$ | async }}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mos-u-spacer--margin-bottom-lg">
      <div class="columns" [ngClass]="(isMobile$ | async) ? 'small-12' : 'medium-5'">
        <div class="mos-u-shadow-depth-2 dsp-widget-background mos-u-border--top-md" [id]="'asset-allocation'">
          <div *ngIf="loading$ | async" class="row">
            <div class="dsp-overview-spinner-wrapper" [style.height.px]="521">
              <div class="dsp-overview-spinner"></div>
            </div>
          </div>
          <ng-container *ngIf="!(loading$ | async)">
            <div id="holdings-pendo-row" class="row mos-u-spacer--padding-md">
              <div id="holdings-pendo-column" class="columns">
                <ng-container *ngIf="showAssetAllocation$ | async">
                  <h3 class="mos-u-spacer--margin-none" [id]="'asset-allocation-header'">
                    <a class="dsp-link" *ngIf="!(isMobile$ | async)" routerLink="/holdings"
                      [id]="'asset-allocation-link'">
                      Holdings
                      <atlas-icon [id]="'asset-allocation-link-icon'" [icon]="'hyperlink'"
                        [collection]="'user-interface'" [size]="'medium'" [alt]="'link'"></atlas-icon>

                    </a>
                    <span *ngIf="(isMobile$ | async)" [id]="'asset-allocation-link'">
                      Holdings
                      <atlas-icon [id]="'asset-allocation-link-icon'" [icon]="'hyperlink'"
                        [collection]="'user-interface'" [size]="'medium'" [alt]="'link'"></atlas-icon>
                    </span><atlas-icon *ngIf="(notes$ | async)?.overview[ 'holdings' ] !== undefined"
                      #holdingsTooltip="haloTooltip" (click)="holdingsTooltip.toggle(); $event.stopPropagation()"
                      class="dsp-overview-tooltip-trigger" [haloTooltipWithArrow]="true"
                      [haloTooltip]="(notes$ | async)?.overview[ 'holdings' ]"
                      [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                      [haloTooltipClass]="(isMobile$ | async) ? 'dsp-overview-mobile-tooltip' : null"
                      [haloTooltipTouchGestures]="'on'" [id]="'holdings-note-icon'" [icon]="'c-info'"
                      [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                    </atlas-icon>
                  </h3>
                  <p class="mos-u-spacer--margin-none dsp-widget-subtitle">
                    as at end of
                    <span [id]="'asset-allocation-date'">{{ assetAllocationDate$ | async }}</span>
                  </p>
                </ng-container>
                <ng-container *ngIf="!(showAssetAllocation$ | async)">
                  <h3 [id]="'asset-allocation-header'" class="mos-u-spacer--margin-none">
                    Holdings
                  </h3>
                  <div [style.min-height.px]="24"></div>
                </ng-container>
              </div>
            </div>
            <div class="row">
              <div class="columns mos-u-align-center--both dsp-allocation-chart-container">
                <div dsp-chart [id]="'asset-allocation-chart'" *ngIf="showAssetAllocation$ | async"
                  [chart]="assetAllocationChart$ | async" class="dsp-allocation-chart"></div>
                <h3 *ngIf="!(showAssetAllocation$ | async)" [id]="'asset-allocation-no-data'">
                  No Data Available
                </h3>
              </div>

              <div class="dsp-allocation-slides-paginator">
                <span *ngIf="showAssetAllocation$ | async" class="mos-u-text-size--xsm">
                  {{ assetAllocationLegendPage$ | async }} of {{
                  assetAllocationLegendTotal$ | async }}
                </span>
              </div>
            </div>
            <div *ngIf="showAssetAllocation$ | async" [id]="'asset-allocation-legend'" class="dsp-widget-legend">
              <legacy-carousel [disableAutoRotate]="(assetAllocationLegend$ | async).length === 1"
                [autoSlideHeight]="true" [enableFixedHeight]="true" [animationTime]="1" [slideDuration]="5"
                [disableDrag]="true" [slidesVisible]="1" [showDots]="false" [showArrows]="true"
                [nextInnerIconSize]="'lg'" [previousInnerIconSize]="'lg'" [stepSize]="1"
                (onChange)="onLegendSlide($event)">
                <legacy-carousel-slide *ngFor="let slide of assetAllocationLegend$ | async; let slideId = index">
                  <div class="row" [style.height.%]="100">
                    <div class="column dsp-carousel-column">
                      <div class="row dsp-legend-row">
                        <div *ngFor="let legend of slide; let fundId = index"
                          [id]="'asset-allocation-legend-slide-' + slideId + '-' + fundId"
                          class="columns medium-12 mos-u-align-center--vertical">
                          <div class="mos-u-align-center--both">
                            <div class="dsp-circle mos-u-display--inline-block"
                              [id]="'asset-allocation-legend-circle-' + slideId + '-' + fundId"
                              [ngClass]="'dsp-bg-color--' + legend.color"></div>
                          </div>
                          <div class="mos-u-spacer--margin-left-sm mos-u-text-overflow">
                            <span class="mos-u-text-size--xsm"
                              [id]="'asset-allocation-legend-name-' + slideId + '-' + fundId">
                              {{ legend.name }}
                            </span>
                          </div>
                          <span class="mos-u-text-size--xsm mos-u-font-weight--medium"
                            [id]="'asset-allocation-legend-percent-' + slideId + '-' + fundId"
                            [style.margin-left]="'auto'">
                            {{ legend.allocation | decimal }}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </legacy-carousel-slide>
              </legacy-carousel>
            </div>
            <div *ngIf="!(showAssetAllocation$ | async)" [style.min-height.px]="100"></div>
          </ng-container>
        </div>
      </div>

      <div *ngIf="!(isMobile$ | async)" class="columns medium-7">
        <div class="mos-u-shadow-depth-2 dsp-widget-background mos-u-border--top-md" [id]="'investment-growth'">
          <div *ngIf="loading$ | async" class="row">
            <div class="dsp-overview-spinner-wrapper" [style.height.px]="521">
              <div class="dsp-overview-spinner"></div>
            </div>
          </div>
          <ng-container *ngIf="!(loading$ | async)">
            <div id="growth-of-investment-pendo-row" class="row mos-u-spacer--padding-md">
              <div id="growth-of-investment-pendo-column" class="columns">
                <ng-container *ngIf="showInvestmentGrowth$ | async">
                  <h3 class="mos-u-spacer--margin-none" [id]="'investment-growth-header'">
                    <a class="dsp-link" [routerLink]="'/valuation'" [id]="'investment-growth-link'">
                      Growth Of Investments
                      <atlas-icon [id]="'investment-growth-link-icon'" [icon]="'hyperlink'"
                        [collection]="'user-interface'" [size]="'medium'" [alt]="'link'"></atlas-icon>


                    </a><atlas-icon *ngIf="(notes$ | async)?.overview[ 'investment-growth' ] !== undefined"
                      #investmentGrowthTooltip="haloTooltip"
                      (click)="investmentGrowthTooltip.toggle(); $event.stopPropagation()"
                      class="dsp-overview-tooltip-trigger" [haloTooltipWithArrow]="true"
                      [haloTooltip]="(notes$ | async)?.overview[ 'investment-growth' ]"
                      [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'bottom'" [haloTooltipShowDelay]="100"
                      [haloTooltipClass]="(isMobile$ | async) ? 'dsp-overview-mobile-tooltip' : null"
                      [haloTooltipTouchGestures]="'on'" [id]="'growth-of-investments-note-icon'" [icon]="'c-info'"
                      [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                    </atlas-icon>


                  </h3>
                  <p class="mos-u-spacer--margin-none dsp-widget-subtitle">
                    as at
                    <span [id]="'investment-growth-date'">{{ investmentGrowthDate$ | async }}</span>
                  </p>
                </ng-container>
                <ng-container *ngIf="!(showInvestmentGrowth$ | async)">
                  <h3 [id]="'investment-growth-header'" class="mos-u-spacer--margin-none">
                    Growth Of Investments
                  </h3>
                  <div [style.min-height.px]="24"></div>
                </ng-container>
              </div>
            </div>
            <div class="row">
              <div class="columns mos-u-align-center--both dsp-chart-container">
                <div dsp-chart [id]="'investment-growth-chart'" *ngIf="showInvestmentGrowth$ | async"
                  [chart]="investmentGrowthChart$ | async" class="dsp-growth-chart"></div>
                <h3 *ngIf="!(showInvestmentGrowth$ | async)" [id]="'investment-growth-no-data'">
                  No Data Available
                </h3>
              </div>
            </div>
            <div *ngIf="showInvestmentGrowth$ | async" [id]="'investment-growth-legend'"
              class="dsp-widget-legend mos-u-align-center--vertical">
              <div class="row mos-u-spacer--padding-md">
                <div class="columns mos-u-align-center--vertical">
                  <div>
                    <div class="dsp-circle mos-u-display--inline-block dsp-bg-color--3"
                      [id]="'investment-growth-legend-circle'"></div>
                  </div>
                  <span class="mos-u-text-size--xsm mos-u-spacer--margin-left-sm"
                    [id]="'investment-growth-legend-name'">
                    Total Portfolio
                  </span>
                </div>
              </div>
            </div>
            <div *ngIf="!(showInvestmentGrowth$ | async)" [style.min-height.px]="100"></div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="row mos-u-spacer--margin-bottom-lg">
      <div class="columns medium-12">
        <div class="mos-u-shadow-depth-2 dsp-widget-background mos-u-border--top-md" id="valuation-performance">
          <div *ngIf="loading$ | async" class="row">
            <div class="dsp-overview-spinner-wrapper" [style.height.px]="521">
              <div class="dsp-overview-spinner"></div>
            </div>
          </div>
          <ng-container *ngIf="!(loading$ | async)">
            <div id="valuation-performance-pendo-row" class="row mos-u-spacer--padding-md">
              <div id="valuation-performance-pendo-column" class="columns">
                <ng-container *ngIf="showPerformanceValuation$ | async">
                  <h3 class="mos-u-spacer--margin-none" [id]="'performance-valuation-header'">
                    <a *ngIf="(isMobile$ | async)" class="dsp-link" routerLink="/valuation"
                      [id]="'performance-valuation-link'">
                      Valuation

                      <atlas-icon [id]="'asset-allocation-link-icon'" [icon]="'hyperlink'"
                        [collection]="'user-interface'" [size]="'medium'" [alt]="'link'"></atlas-icon>
                    </a>
                    <a *ngIf="!(isMobile$ | async)" class="dsp-link" routerLink="/performance"
                      [id]="'performance-valuation-link'">
                      <span>Valuation and Performance</span>
                      <span>
                        ({{ ((performanceValuationType$ | async) === 'gross' ?
                        'gross of fees' : 'net of fees') | titlecase }})
                      </span>

                      <atlas-icon [id]="'asset-allocation-link-icon'" [icon]="'hyperlink'"
                        [collection]="'user-interface'" [size]="'medium'" [alt]="'link'"></atlas-icon>
                    </a><atlas-icon *ngIf="(notes$ | async)?.overview[ 'performance-valuation' ] !== undefined"
                      #performanceValuationTooltip="haloTooltip"
                      (click)="performanceValuationTooltip.toggle(); $event.stopPropagation()"
                      class="dsp-overview-tooltip-trigger" [haloTooltipWithArrow]="true"
                      [haloTooltip]="(notes$ | async)?.overview[ 'performance-valuation' ]"
                      [haloTooltipPosition]="(isMobile$ | async) ? 'top' : 'right'" [haloTooltipShowDelay]="100"
                      [haloTooltipClass]="(isMobile$ | async) ? 'dsp-overview-mobile-tooltip' : null"
                      [haloTooltipTouchGestures]="'on'" [id]="'performance-valuation-note-icon'" [icon]="'c-info'"
                      [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                    </atlas-icon>
                  </h3>

                </ng-container>
                <ng-container *ngIf="!(showPerformanceValuation$ | async)">
                  <h3 [id]="'performance-valuation-header'" class="mos-u-spacer--margin-none">
                    Valuation
                    <h3 *ngIf="!(isMobile$ | async)">and Performance</h3>
                  </h3>
                  <div [style.min-height.px]="24"></div>
                </ng-container>
              </div>
              <div *ngIf="!(isMobile$ | async)" class="columns shrink" [style.margin-left]="'auto'">

                <atlas-dropdown [placement]="dropdownPlacementLeftStart" *ngIf="showPerformanceValuation$ | async"
                  [icon]="'more_vert'" [iconSize]="iconSize" [iconSheetUrl]="iconSheetUrl" [disabled]="disabled"
                  [iconButtonAlt]="'More options'" [iconAriaTitle]="'More options'"
                  [triggerType]="dropdownTriggerTypeIconButton" data-testid="dropdown-playground_955432335">
                  <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'"
                    data-testid="dropdown-playground_231896144">
                    <atlas-menu-item>
                      <a [id]="'performance-toggle-gross-net'" (click)="onChangePerformanceType()">
                        {{ ((performanceValuationType$ | async) === 'gross' ?
                        'net of fees' : 'gross of fees') | titlecase }}
                      </a>
                    </atlas-menu-item>
                    <atlas-menu-item>
                      <a [id]="'performance-toggle-expand-all'">
                        <atlas-switch [value]="performanceValuationRowsExpanded$ | async" [color]="'brand'"
                          (onClick)="onToggleRows($event)">
                          Collapse / Expand All
                        </atlas-switch>
                      </a>
                    </atlas-menu-item>
                  </atlas-menu>
                </atlas-dropdown>
              </div>
            </div>
            <div class="row mos-u-spacer--padding-md">
              <div class="columns" [ngClass]="{ 'mos-u-align-center--both': !(showPerformanceValuation$ | async) }"
                [style.min-height.px]="330">
                <atlas-table *ngIf="showPerformanceValuation$ | async" [id]="'overview-performance-table'"
                  [ngClass]="{ 'dsp-overview-performance-mobile': (isMobile$ | async) }">

                  <thead atlas-table-header #header>
                    <tr atlas-table-row>
                      <th *ngIf="!(isMobile$ | async)" colspan="2">
                      </th>
                      <th *ngIf="(performanceValuationDate$ | async)" colspan="10">

                        <p class="mos-u-spacer--margin-none dsp-widget-subtitle">
                          <span [id]="'performance-valuation-date'">
                            as at end of {{ performanceValuationDate$ | async }}</span>
                        </p>
                      </th>
                      <th *ngIf="(performanceValuationHoldingDate$ | async) && !(isMobile$ | async)">
                        <p class="mos-u-spacer--margin-none dsp-widget-subtitle">
                          <span [id]="'performance-valuation-holding-date'">
                            as at {{ performanceValuationHoldingDate$ | async }}</span>
                        </p>
                      </th>
                    <tr style="border: 1px solid red;"></tr>
                    <!-- </tr> -->
                    <tr atlas-table-row>
                      <th atlas-table-header-cell *ngFor="let col of performanceValuationHeaders$ | async"
                        [columnDef]="col">
                        {{ col.name }}<atlas-icon *ngIf="col.fieldKey === 'MTD'" #mtdTooltip="haloTooltip"
                          (click)="mtdTooltip.toggle(); $event.stopPropagation()" class="dsp-overview-tooltip-trigger"
                          [id]="'mtd-note-icon'" [haloTooltipWithArrow]="true" [haloTooltip]="col.tooltip"
                          [haloTooltipPosition]="'top'" [haloTooltipShowDelay]="100" [haloTooltipTouchGestures]="'on'"
                          [icon]="'c-info'" [collection]="'user-interface'" [size]="'small'"></atlas-icon>
                      </th>
                    </tr>
                  </thead>

                  <tbody atlas-table-body>
                    <tr halo-table-row
                      *ngFor="let row of performanceValuationTable$ | async | sort:header.sortOption;let index=index">

                      <ng-container *ngIf="!row.parent">
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }">
                          <atlas-icon-button *ngIf="(index === 0 && ShowClientPerfromance) || (index > 0)"
                            class="cursor-pointer" (click)="onClickFundRow(row._id, $event)" [size]="'small'"
                            [icon]="row.expanded ? 'chevron-up' : 'chevron-down'"
                            [collection]="'arrows-solid'"></atlas-icon-button>

                        </td>
                        <td atlas-table-cell class="mos-u-text-left" [ngClass]="{ 'dsp-row-border': index !== 0 }">
                          {{ row.name ? row.name : '-' }}
                        </td>
                        <td atlas-table-cell [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row.closing ? (row.closing | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '1m' ] ? (row[ '1m' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '3m' ] ? (row[ '3m' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ 'CYTD' ] ? (row[ 'CYTD' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ 'FYTD' ] ? (row[ 'FYTD' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '1y' ] ? (row[ '1y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '3y' ] ? (row[ '3y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '5y' ] ? (row[ '5y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '7y' ] ? (row[ '7y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font">
                          {{ row[ '10y' ] ? (row[ '10y' ] | decimal) : '-' }}
                        </td>

                        <td atlas-table-cell *ngIf="!(isMobile$ | async)" [ngClass]="{ 'dsp-row-border': index !== 0 }"
                          class="mos-u-text-right dsp-numeric-font mtd">
                          {{ row[ 'MTD' ] ? (row[ 'MTD' ] | decimal) : '-' }}
                        </td>
                      </ng-container>
                      <ng-container *ngIf="!(isMobile$ | async) && row.parent && row.expanded">
                        <td atlas-table-cell class="dsp-table-row"></td>
                        <td atlas-table-cell class="mos-u-text-left dsp-table-row">
                          {{ row.name ? row.name : '-' }}

                          <atlas-icon *ngIf="row.tooltip !== undefined" #rowTooltip="haloTooltip"
                            (click)="rowTooltip.toggle(); $event.stopPropagation()" class="dsp-overview-tooltip-trigger"
                            [haloTooltipWithArrow]="true" [haloTooltip]="row.name" [haloTooltipPosition]="'right'"
                            [haloTooltipShowDelay]="100" [haloTooltipTouchGestures]="'on'"
                            [id]="'valuation-performance-benchmark-name-icon-' + index" [icon]="'c-info'"
                            [collection]="'user-interface'" [size]="'small'" [alt]="'info'">
                          </atlas-icon>
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row.closing ? (row.closing | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '1m' ] ? (row[ '1m' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '3m' ] ? (row[ '3m' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ 'CYTD' ] ? (row[ 'CYTD' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ 'FYTD' ] ? (row[ 'FYTD' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '1y' ] ? (row[ '1y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '3y' ] ? (row[ '3y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '5y' ] ? (row[ '5y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '7y' ] ? (row[ '7y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ '10y' ] ? (row[ '10y' ] | decimal) : '-' }}
                        </td>
                        <td atlas-table-cell class="mos-u-text-right dsp-table-row dsp-numeric-font">
                          {{ row[ 'MTD' ] ? (row[ 'MTD' ] | decimal) : '-' }}
                        </td>
                      </ng-container>

                    </tr>
                  </tbody>
                </atlas-table>
                <div *ngIf="showPerformanceValuation$ | async" class="column medium-3 pagination-container"
                  style="justify-content: left;">
                  <span class="pagination-span" *ngIf="(performanceValuationPagination$ | async)?.total > 0">
                    Showing {{
                    (((performanceValuationPagination$ | async)?.page - 1) * (performanceValuationPagination$ |
                    async)?.itemsByPage) + 1
                    }} to {{
                    getMin((performanceValuationPagination$ | async)?.page * (performanceValuationPagination$ |
                    async)?.itemsByPage, (performanceValuationPagination$ |
                    async)?.total)
                    }} of {{ (performanceValuationPagination$ | async)?.total }} entries
                  </span>
                  <span *ngIf="(performanceValuationPagination$ | async)?.total === 0">
                    Showing 0 to 0 of 0 entries
                  </span>
                </div>
                <div *ngIf="showPerformanceValuation$ | async"
                  class="mos-u-spacer--margin-top-sm mos-u-spacer--margin-bottom-sm">
                  <span class="mos-u-footnote">
                    * Closing Balance calculated utilizing Redemption / Exit
                    Price
                  </span>
                </div>
                <h3 *ngIf="!(showPerformanceValuation$ | async)" [id]="'performance-valuation-no-data'">
                  No Data Available
                </h3>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</div>